import { managerInstance } from "libs/api";
import { DeliveryCompany } from "modules/deliveryCompanies";

export interface UpdateCompanySettingsRequest {
  name?: string;
  email?: string;
  password?: string;
  capacity?: number;
  phoneNumber?: string;
  address?: string;
  avatarMediaId?: string | null;
}

export const requestUpdateCompanySettings = async (
  body: UpdateCompanySettingsRequest
): Promise<DeliveryCompany> => {
  return await managerInstance.patch("/delivery-company/me", body);
};
